import A11yDialog from 'a11y-dialog';
import { getCookie, setCookie } from '../helpers/cookies';

const el = document.getElementById('a11y-dialog');

const initializeModal = () => {
  const dialog = new A11yDialog(el);
  const html = document.documentElement;

  dialog.on('show', () => {
    html.classList.add('modal-active');
    html.style.overflowY = 'hidden';
  });
  dialog.on('hide', () => {
    html.classList.remove('modal-active');
    html.style.overflowY = '';
    console.log('closed');
    setTimeout(() => dialog.destroy(), 400);
  });
  dialog.on('destroy', () => el.remove());

  dialog.show();
};

if (el) {
  const cookieName = el.getAttribute('data-cookie-name');
  const cookieFrequency = el.getAttribute('data-frequency');
  if (!getCookie(cookieName)) {
    initializeModal();
    if (cookieFrequency === 'session') {
      setCookie(cookieName, 'shown');
    } else {
      const cookieDuration = {
        week: 7,
        month: 30,
        once: 999,
      };
      setCookie(cookieName, 'shown', cookieDuration[cookieFrequency]);
    }
  }
}
